import React, { useState } from 'react';
import { Button, InputGroup, TemplateModal, Textarea } from '@nearst/ui';
import * as Sentry from '@sentry/browser';
import { hideProducts } from '@services/stock';

import { sendAnalytics } from '../../../../utils/sendAnalytics';

import styles from './BarcodeVisibilityModal.module.scss';
import ResultsSection from './ResultsSection';

const BarcodeVisibilityModal = ({ open, close, shop, mutate, operation }) => {
	const [errorMsg, setErrorMsg] = useState('');
	const [barcodeInput, setBarcodeInput] = useState();
	const [loading, setLoading] = useState(false);
	const [results, setResults] = useState([]);

	const handleChange = (e) => {
		const barcodes = e.target.value.split('\n').filter((str) => str);
		if (barcodes.length > 100) {
			setErrorMsg('Please enter a maximum of 100 barcodes');
			setBarcodeInput(barcodes.slice(0, 100).join('\n'));
		} else {
			setBarcodeInput(e.target.value);
		}
		setResults([]);
	};

	const handleSubmit = () => {
		if (!barcodeInput) {
			setErrorMsg('Please enter a valid barcode');
			return;
		}
		const barcodes = barcodeInput.split('\n').filter((str) => str);
		if (barcodes.length > 100) {
			setErrorMsg('Please enter a maximum of 100 barcodes');
			return;
		}

		setLoading(true);
		hideProducts(shop.id, barcodes, operation.enabled)
			.then((response) => {
				sendAnalytics('Barcode Form', operation.analyticsAction, shop.name);
				setResults(response);
				setLoading(false);
				mutate();
			})
			.catch((e) => {
				console.error(e);
				Sentry.captureException(e);
				setErrorMsg('Something went wrong processing your request');
				setResults([]);
				setLoading(false);
			})
			.finally(() => setLoading(false));
	};

	return (
		<TemplateModal isOpen={open} onDismiss={close} title={operation.title} showDismissButton={false}>
			<div className={styles.container}>
				<InputGroup label="Enter one barcode per line" htmlFor="barcodes">
					<Textarea
						disabled={loading}
						value={barcodeInput}
						onChange={handleChange}
						placeholder="barcode001&#10;barcode002&#10;barcode003"
					/>
				</InputGroup>
				<p>{errorMsg}</p>

				<div className={styles.buttonContainer}>
					<Button disabled={!barcodeInput || loading} onClick={handleSubmit} primary>
						{operation.buttonText}
					</Button>
				</div>
				<ResultsSection results={results} operation={operation} />

				<p className={styles.disclaimer}>It may take up to an hour before these changes appear across your channels.</p>
			</div>
		</TemplateModal>
	);
};

export default BarcodeVisibilityModal;
